export function functionWithCondition(condition, functionTrue, functionFalse) {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  var fnWithCondition = function fnWithCondition() {
    return condition() ? functionTrue.apply(void 0, arguments) : functionFalse.apply(void 0, arguments);
  };
  return fnWithCondition;
}